import { useLottie } from 'lottie-react';
import React from 'react';
import loadingAnimation from '../../../assets/animations/loading-anim.json';

type props = { height?: number };
export default function LoadingAnimComponent({ height = 800 }: props) {
	return (
		<div className="h-full ml-18 overflow-hidden -mt-16">
			<div className="mx-auto my-auto align-middle overflow-clip w-9/12">
				<div className="mx-auto my-auto self-center">
					<div className="w-9/12 mx-auto">
						<LoadingAnimation height={height} />
					</div>
				</div>
			</div>
		</div>
	);
}

export function SecLoadingAnimComponent({ height = 800 }: props) {
	return (
		<div className="h-full ml-18 ">
			<div className="mx-auto my-auto align-middle overflow-clip w-10/12">
				<div className="mx-auto my-auto self-center">
					<div className="w-8/12 mx-auto">
						<LoadingAnimation height={height} />
					</div>
				</div>
			</div>
		</div>
	);
}

export function LoadingAnimation({ height = 800 }: props) {
	const options = {
		style: { height: height },
		animationData: loadingAnimation,
		loop: true,
		autoplay: true
	};

	const { View } = useLottie(options);

	return View;
}
